import { useEffect, useState } from "react";
import {
  CompanyManageGetCompanyStoreStockByColor,
  CompanyManageMyStore,
  ProductFilterBerand,
} from "../../Api/Services";
import InputCus from "../../Component/InputCus/Text/InputCus";

function CompanyStoreStockByColor() {
  const [isLoading, setLoading] = useState(true);
  const [CompanyStore, setCompanyStore] = useState([]);
  const [AllStock, setAllStock] = useState([]);
  const [CompanyStoreId, setCompanyStoreId] = useState();
  const [brands, setBrands] = useState([]);
  const [activeItem, setActiveItem] = useState(null);
  const [SearchName, setSearchName] = useState("");

  const start = async () => {
    setCompanyStore([]);
    setCompanyStoreId();
    try {
      const CompanyManageMyStoreData = await CompanyManageMyStore();
      if (
        CompanyManageMyStoreData.status &&
        CompanyManageMyStoreData.status === 200
      ) {
        setCompanyStore(CompanyManageMyStoreData.data.data);
        if (CompanyManageMyStoreData.data.data.length > 0) {
          let id = CompanyManageMyStoreData.data.data[0].companyStoreId;

          setCompanyStoreId(id);
          const CompanyManageGetCompanyStoreStockByColorData =
            await CompanyManageGetCompanyStoreStockByColor(id);
          if (
            CompanyManageGetCompanyStoreStockByColorData.status &&
            CompanyManageGetCompanyStoreStockByColorData.status === 200
          ) {
            setAllStock(CompanyManageGetCompanyStoreStockByColorData.data.data);
          }

          const ProductFilterBerandData = await ProductFilterBerand({});
          if (
            ProductFilterBerandData.status &&
            ProductFilterBerandData.status === 200
          ) {
            setBrands(ProductFilterBerandData.data.data.data);
          }
        }
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    start();
  }, []);

  const handleClick = (key) => {
    setActiveItem(activeItem === key ? null : key);
  };

  const setStore = async (id) => {
    setCompanyStoreId(id);
    setLoading(true);
    try {
      const CompanyManageGetCompanyStoreStockByColorData =
        await CompanyManageGetCompanyStoreStockByColor(id);
      if (
        CompanyManageGetCompanyStoreStockByColorData.status &&
        CompanyManageGetCompanyStoreStockByColorData.status === 200
      ) {
        setAllStock(CompanyManageGetCompanyStoreStockByColorData.data.data);
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {isLoading && (
        <div className="d-flex justify-content-center align-items-center">
          <div className="lds-facebook">
            <div />
            <div />
            <div />
          </div>
        </div>
      )}
      <div className={isLoading ? "startLoading" : "stateLoading"}>
        <div className="w-100 d-flex justify-content-start align-items-start flex-column element p-5">
          <div className="w-100 d-flex justify-content-start align-items-start flex-column element p-5">
            <div className="d-flex justify-content-between align-items-center">
              {CompanyStore &&
                CompanyStore.map((item, key) => (
                  <div className="border border-3 border-black m-2 rounded">
                    <button
                      onClick={() => {
                        setStore(item.companyStoreId);
                      }}
                      className={`m-2 border rounded-5 h6 ps-3 pe-3 pt-1 pb-2 ${
                        CompanyStoreId == item.companyStoreId
                          ? "bg-warning"
                          : ""
                      }`}
                    >
                      {item.companyStoreCompanyName +
                        " ( " +
                        item.companyStoreName +
                        " ) "}
                    </button>
                  </div>
                ))}
            </div>
            {CompanyStoreId && (
              <div className="w-100">
                <div className="d-flex justify-content-between align-items-center w-100 ">
                  <h5>
                    تعداد کل کالای انبار :
                    {AllStock.reduce((sum, item) => {
                      return (
                        sum +
                        item.stocks.reduce(
                          (subSum, stockItem) => subSum + stockItem.stock,
                          0,
                        )
                      );
                    }, 0)}
                  </h5>
                </div>
                <div className="d-flex">
                  <InputCus
                    className="m-2"
                    type="text"
                    name="name"
                    id="name"
                    text="نام"
                    value={SearchName}
                    onChange={(e) => {
                      setSearchName(e.target.value);
                    }}
                  />
                </div>
                {brands.map(
                  (b, key) =>
                    AllStock.filter((e) => e.productProductBerandId == b.id)
                      .length > 0 && (
                      <>
                        <div
                          key={b}
                          className="d-flex justify-content-around align-items-center w-100 p-3 mt-4 pointer bg-body-secondary border border-1 border-black"
                          onClick={() => handleClick(b.id)}
                        >
                          <h5>
                            {b.name}
                            {" - "}
                            {AllStock.filter(
                              (e) => e.productProductBerandId == b.id,
                            ).reduce((sum, item) => {
                              return (
                                sum +
                                item.stocks.reduce(
                                  (subSum, stockItem) =>
                                    subSum + stockItem.stock,
                                  0,
                                )
                              );
                            }, 0)}
                          </h5>
                        </div>
                        {activeItem === b.id && (
                          <div className="d-flex justify-content-center align-items-center w-100 tableC">
                            <table
                              className="table"
                              style={{ lineHeight: "normal" }}
                            >
                              <thead className="sticky-header">
                                <tr className="trTable">
                                  <th>نام کالای</th>
                                  <th>موجودی</th>
                                </tr>
                              </thead>
                              <tbody className="identitystyle">
                                {AllStock &&
                                  AllStock.filter(
                                    (e) => e.productProductBerandId == b.id,
                                  )
                                    .filter((itemPro) => {
                                      const productFilter =
                                        SearchName?.toUpperCase?.() || "";
                                      const Pro =
                                        (
                                          (itemPro.productProductBerandName !=
                                            " " &&
                                            itemPro.productProductBerandName +
                                              " ") +
                                          (itemPro.productProductTypeName !=
                                            " " &&
                                            itemPro.productProductTypeName +
                                              " ") +
                                          (itemPro.productProductSeriesName !=
                                            " " &&
                                            itemPro.productProductSeriesName) +
                                          itemPro.productSymbol +
                                          (itemPro.productProductSeriesEndName !=
                                          " "
                                            ? itemPro.productProductSeriesEndName +
                                              " "
                                            : " ") +
                                          (itemPro.productProductRamName !=
                                            " " &&
                                            itemPro.productProductRamName +
                                              "/") +
                                          (itemPro.productProductRomName !=
                                            " " &&
                                            itemPro.productProductRomName +
                                              " ") +
                                          (itemPro.productProductNetworkName !=
                                            " " &&
                                            itemPro.productProductNetworkName +
                                              " ") +
                                          (itemPro.productProductCountryName !=
                                            " " &&
                                            itemPro.productProductCountryName +
                                              " ") +
                                          (itemPro.productIsInsurance && "بیمه")
                                        )?.toUpperCase?.() || "";
                                      return Pro.includes(productFilter);
                                    })

                                    .map((itemPro, keyPro) => (
                                      <tr key={keyPro}>
                                        <td>
                                          {itemPro.productProductTypeName !=
                                            " " &&
                                            itemPro.productProductTypeName +
                                              " "}
                                          {itemPro.productProductSeriesName !=
                                            " " &&
                                            itemPro.productProductSeriesName}
                                          {itemPro.productSymbol}
                                          {itemPro.productProductSeriesEndName !=
                                          " "
                                            ? itemPro.productProductSeriesEndName +
                                              " "
                                            : " "}
                                          {itemPro.productProductRamName !=
                                            " " &&
                                            itemPro.productProductRamName + "/"}
                                          {itemPro.productProductRomName !=
                                            " " &&
                                            itemPro.productProductRomName + " "}
                                          {itemPro.productProductNetworkName !=
                                            " " &&
                                            itemPro.productProductNetworkName +
                                              " "}
                                          {itemPro.productProductCountryName !=
                                            " " &&
                                            itemPro.productProductCountryName +
                                              " "}
                                          {itemPro.productIsInsurance && "بیمه"}
                                        </td>
                                        <td>
                                          {itemPro.stocks
                                            .filter(
                                              (itemStock) =>
                                                itemStock.stock > 0,
                                            )
                                            .map((itemStock) => (
                                              <div key={itemStock.id}>
                                                {
                                                  itemStock.productProductColorName
                                                }{" "}
                                                - {itemStock.stock}
                                              </div>
                                            ))}
                                        </td>
                                      </tr>
                                    ))}
                              </tbody>
                            </table>
                          </div>
                        )}
                      </>
                    ),
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
export default CompanyStoreStockByColor;
